export default "__VITE_ASSET__8ed80230__"